// extracted by mini-css-extract-plugin
export default {"content":"styles_content__Bp5E-","buttonContent":"styles_buttonContent__XhMHc","drawerAdornment":"styles_drawerAdornment__N13nQ","startShipments":"styles_startShipments__mvQpL"};